module.exports = __webpack_public_path__ + "img/download-3-1.f1fb617a.png";